export default __webpack_public_path__ + "static/media/tablet-bg.06bfaa4f.png";